import { CHART_COLORS } from 'domains/Statistics/utils';

export const ACQUISITION_SUMMARY_CHART_COLORS = {
  revenue: CHART_COLORS.seaGreen,
  sales: CHART_COLORS.deepPurple,
};
